/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Alternatives_IntroInputs */

const en_directory_alternatives_intro = /** @type {(inputs: Directory_Alternatives_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Curated alternatives to ${i?.name} — compare features, pricing, and editorial notes to find the right tool for your workflow.`)
};

const zh_directory_alternatives_intro = /** @type {(inputs: Directory_Alternatives_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`精选 ${i?.name} 的替代方案——比较功能、定价与编辑点评，找到更适合你工作流的工具。`)
};

/**
* | output |
* | --- |
* | "Curated alternatives to {name} — compare features, pricing, and editorial notes to find the right tool for your workflow." |
*
* @param {Directory_Alternatives_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_intro = /** @type {((inputs: Directory_Alternatives_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_intro(inputs)
	return zh_directory_alternatives_intro(inputs)
});
export { directory_alternatives_intro as "directory.alternatives.intro" }